import { EventEmitter } from 'events';

const pubSub = new EventEmitter();
export default pubSub;